import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DsGeneralIP, SaveEventType, SaveStatusObj, SOModule, SSOStatus, UserType, ValidationItem, ValidationSummary } from '../../../../shared/misc-classes';
import { DataService } from '../../../../shared/dataservice.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ValidationDialog } from '../../../../dialogs/validation-dialog/validation-dialog';

@Component({
  selector: 'ds-general',
  templateUrl: './ds-general.component.html',
  styleUrls: ['./ds-general.component.css']
})
export class DsGeneralComponent implements OnInit, OnChanges {

  @Input() dsGeneralObj: DsGeneralIP;
  @Input() soLockObtained:boolean;
  @Input() accessLevel: Array<UserType>;
  @Output() updateDatasheet: EventEmitter<SaveStatusObj> = new EventEmitter();
  
  disableForm: boolean = false;
  inputDisableMessage: string = 'This form is not yet enabled';
  readonlyAccess : boolean = false;
  Hvr:any = {};
  tempRiseLimitApplicable:boolean = false;
  hasAccessEE: boolean = false;
  hasAccessME: boolean = false;
  hasAccessPM: boolean = false;
  lockFields:boolean = false; // After HOM lock

  constructor(public _dataService: DataService, public dialog: MatDialog) { }

  ngOnInit(): void {
  }
  ngOnChanges(): void {
     this.disableForm = true;
    if(this.soLockObtained == false){
      this.inputDisableMessage = "You can't Edit";
    }
    else if (!this.dsGeneralObj.isInputEnabled) {
      this.inputDisableMessage = "This form is not yet enabled";
    }
    else if (this.accessLevel.includes(this._dataService.userType) == false) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else {
      this.disableForm = false;
      // this.checkUserEnabled();
    }
    if(this._dataService.hasReadOnlyAccess){
      this.readonlyAccess = true;
    }
    this.hasAccessEE = this._dataService.userType ===(UserType.ELECTRICAL_ENGINEERING) || this._dataService.userType ===(UserType.MARKETING) || this._dataService.userType ===(UserType.SUPER_ADMIN);
    this.hasAccessME = this._dataService.userType ===(UserType.MECHANICAL_ENGINEERING) || this._dataService.userType ===(UserType.MARKETING) || this._dataService.userType ===(UserType.SUPER_ADMIN);
    this.hasAccessPM = this._dataService.userType ===(UserType.PROJECT_MANAGEMENT) || this._dataService.userType ===(UserType.MARKETING) || this._dataService.userType ===(UserType.SUPER_ADMIN);
    if (!this.dsGeneralObj.parentSORef.isDatasheetSubOrderEnabled) {
      this.lockFields = false;
    }
    else {
      this.lockFields = true;
    }
  }
  sectionNoteChangePM(_event: any) {
    this.dsGeneralObj.sectionNotePM = _event.target.value;
  }
  sectionNoteChangeEE(_event: any) {
    this.dsGeneralObj.sectionNoteEE = _event.target.value;
  }
  sectionNoteChangeME(_event: any) {
    this.dsGeneralObj.sectionNoteME = _event.target.value;
  }

  saveDS(_submitToNextSection:boolean){
    if(this.updateDatasheet){
      this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, 
          (_submitToNextSection == true ? SaveEventType.Submit_To_Next:SaveEventType.Save_Data)));
    }
  }
  deleteDS(_deleteDS:boolean){
    if(this.updateDatasheet){
      this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, SaveEventType.Delete_Datasheet));
    }
  }
  reloadData(){
    if(this.updateDatasheet){
      this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, SaveEventType.Reload_Data));
    }
  }
  showSoValidation() {
    let _validList: Array<ValidationItem> = [];
    _validList.push(
      new ValidationItem("Main System", (this.dsGeneralObj.mainSystem ? true : false), " required to save Datasheet."),
      new ValidationItem("System Voltage (kV) (~Â±10%)", (this.dsGeneralObj.systemVoltage ? true : false), " required to save Datasheet."),
      new ValidationItem("Rated Voltage (kV)", (this.dsGeneralObj.ratedVoltage ? true : false), " required to save Datasheet."),
      new ValidationItem("Dry Frequency Withstand Voltage", (this.dsGeneralObj.dryFrqWithstdVolt ? true : false), " required to save Datasheet."),
      new ValidationItem("Rated Impulse Voltage", (this.dsGeneralObj.ratedImpulseVoltage ? true : false), " required to save Datasheet."),
      new ValidationItem("Frequency (Hz)", (this.dsGeneralObj.frequency ? true : false), " required to save Datasheet."),
      new ValidationItem("Switchboard Current Rating (A)", (this.dsGeneralObj.switchboardCurrRating ? true : false), " required to save Datasheet."),
      new ValidationItem("Short Time Current Rating and Duration (kA-Sec)", (this.dsGeneralObj.shortTimeCurrRating ? true : false), " required to save Datasheet."),
      new ValidationItem("Dynamic Peak Withstand Current (kAp)", (this.dsGeneralObj.dynamicPeakWithstdCurr ? true : false), " required to save Datasheet."),
      new ValidationItem("Ambient Temperature for Design (Â°C)", (this.dsGeneralObj.ambTempDesign ? true : false), " required to save Datasheet."),
      new ValidationItem("Temp Rise Limit", (this.dsGeneralObj.tempRiseLimit ? true : false), " required to save Datasheet."),
      new ValidationItem("Earthing System", (this.dsGeneralObj.earthingSystem ? true : false), " required to save Datasheet."),
      new ValidationItem("Altitude (m)", (this.dsGeneralObj.altitude ? true : false), " required to save Datasheet."),
      new ValidationItem("Internal Arc rating and Duration (kA-Sec)", (this.dsGeneralObj.internalArcRating ? true : false), " required to save Datasheet."),
      new ValidationItem("Internal Arc Classification", (this.dsGeneralObj.internalArcClassification ? true : false), " required to save Datasheet."),
      new ValidationItem("Type of Installation", (this.dsGeneralObj.typInstallation ? true : false), " required to save Datasheet.")
    );
    if (this.dsGeneralObj.isTempRiseLimitSpecialReqApplic) {
      _validList.push(new ValidationItem("Special Requirement", this.dsGeneralObj.tempRiseLimitSpecialReq ? true : false, " required to save Datasheet."))
    };


    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);

    this.dialog.open(ValidationDialog, {
      width: '50%',
      data: vSummaryObj
    });
  }

}

